import { render, staticRenderFns } from "./referral.page.vue?vue&type=template&id=9bf68fde&scoped=true&"
import script from "./referral.page.vue?vue&type=script&lang=js&"
export * from "./referral.page.vue?vue&type=script&lang=js&"
import style0 from "./referral.page.vue?vue&type=style&index=0&id=9bf68fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf68fde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VForm,VIcon})
